module.exports = __webpack_public_path__ + "static/media/info_icon.28c49299.png";